import { isValid, format } from "date-fns";
import { IValidDate } from "interfaces/IValidDate";

/**
 * Method that formats dates to DD-MM-YYYY and joins it with -
 */
export const parseDateDDMMYYY = (date: Date) => {
    const localeDate = date.toLocaleDateString("es-MX");
    const splitDate = localeDate.split("/");
    const joinDate = splitDate.join("-");
    return joinDate;
}

/**
 * Method that validates and returns the date as a string at specified format
 */
export const validDate = (value: string | undefined, formatString: string): IValidDate => {
    if(!value) {
        return { isValid: false, formattedDate: "" };
    }
    const date = new Date(value);
    const isDateValid = isValid(date);
    const formattedDate = isDateValid ? format( date, formatString) : "";
    return { isValid: isDateValid, formattedDate };
}